module.exports = __webpack_public_path__ + "static/media/Colette Ray Single Headboard - 120 cm_Dark Blue.e9342ad3.png";